// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__d96 {
  display: flex;
  align-items: center;
  max-width: calc(var(--ring-unit) * 59);
}

.dropdown__df4 {
  flex: 0 0 auto;
  width: calc(var(--ring-unit) * 18);
}

.versionInput__ab4 {
  flex: 1 1 100%;
  margin-left: var(--ring-unit);
}
`, "",{"version":3,"sources":["webpack://./src/modules/ide-provisioner/plugins-rules/plugins-rule/single-plugin-rule/marketplace-plugin-content/version-selector/version-selector.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  max-width: calc(var(--ring-unit) * 59);\n}\n\n.dropdown {\n  flex: 0 0 auto;\n  width: calc(var(--ring-unit) * 18);\n}\n\n.versionInput {\n  flex: 1 1 100%;\n  margin-left: var(--ring-unit);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__d96`,
	"dropdown": `dropdown__df4`,
	"versionInput": `versionInput__ab4`
};
export default ___CSS_LOADER_EXPORT___;
